jQuery(function(){
    // * NCC-739
    // ? - No newsletter at launch
    // ? - Sitecore class feature needs to be setup
    // if (jQuery("#newsletter-modal")) {
    //     console.log("has #newsletter-modal");
    //     jQuery('#newsletter-modal').modaal({
    //         type: 'confirm',
    //         is_locked: true,
    //         overlay_opacity: 0.5,
    //         confirm_button_text: 'Sign Me Up!',
    //         confirm_cancel_button_text: 'Cancel',
    //         hide_close: false,
    //         confirm_content: '<p class="modaal__copy">Please enter your email below to be on the list for new offers and updates</p><form id="newsletter-modal__form"><div class="input__text"><div class="input__text-container" ><label class="label" for="newsletter-modal__email-address">Email</label><input data-parsley-type="email" type="email" name="" id="newsletter-modal__email-address" class="text-field" value="" placeholder="Email" data-parsley-errors-messages-disabled><span class="input__text-placeholder">(Email Address)</span><div class="input__text-error-message"><?xml version="1.0" encoding="utf-8"?> <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><g><path d="M11.499,1C5.148,1,0,6.148,0,12.499s5.148,11.499,11.499,11.499s11.499-5.148,11.499-11.499S17.85,1,11.499,1z M10.999,7C11,6.724,11.224,6.5,11.5,6.5c0.275,0,0.5,0.224,0.499,0.5v7c0.001,0.276-0.224,0.5-0.499,0.5c-0.276,0-0.5-0.224-0.501-0.5V7z M11.518,18.5c-0.006,0-0.012,0-0.018,0c-0.545,0-0.991-0.435-1-0.982c-0.01-0.552,0.43-1.008,0.982-1.017 c0.006,0,0.012-0.001,0.018-0.001c0.545,0,0.99,0.437,1,0.983C12.51,18.035,12.068,18.49,11.518,18.5z"/> </g></g></svg><span></span> </div></div></div></form>',
    //         confirm_callback: function () {
    //         }
    //     });

    //     jQuery('body').on('click', '.modaal__close-link', function (event) {
    //         event.preventDefault();
    //         jQuery('#newsletter-modal').modaal('close');
    //     });

    // }

    // * CNCI-336 - check first before modaal
    if (jQuery("#promo-modal").length) {

        jQuery('#promo-modal').modaal({
            start_open: true,
            close_text: '<svg class="promo__modaal--close" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><rect x="9" class="st0" width="2" height="20"></rect><rect x="9" transform="matrix(4.456506e-11 1 -1 4.456506e-11 20 -4.456506e-10)" class="st0" width="2" height="20"></rect></svg>'
        });

        jQuery(".promo-details__continue").click(function() {
        jQuery(".modaal-close").trigger( "click" );
        });

    }

    if (jQuery("#username-modal").length) {
        jQuery("#username-modal").modaal({
        start_open: true,
        hide_close: true,
        is_locked: true
    });
    }

     if (jQuery(".family_membership_tc").length) {
         jQuery(".family_membership_tc").modaal({
             content_source: '#family_membership_tc',
             close_text: '<svg aria-hidden="true" class="promo__modaal--close" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><rect x="9" class="st0" width="2" height="20" style="fill: #9B9B9B;"></rect><rect x="9" transform="matrix(4.456506e-11 1 -1 4.456506e-11 20 -4.456506e-10)" width="2" height="20" style="fill: #9B9B9B;"></rect></svg>'
         });
     }

     if (jQuery(".express_renewal_tc").length) {
        jQuery(".express_renewal_tc").modaal({
            content_source: '#express_renewal_tc',
            close_text: '<svg aria-hidden="true" class="promo__modaal--close" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><rect x="9" class="st0" width="2" height="20" style="fill: #9B9B9B;"></rect><rect x="9" transform="matrix(4.456506e-11 1 -1 4.456506e-11 20 -4.456506e-10)" width="2" height="20" style="fill: #9B9B9B;"></rect></svg>'
        });
    }

     if (jQuery(".simple-modal").length) {
        jQuery(".simple-modal").each(function(i,e){
            var eleRef=jQuery(e);
            eleRef.modaal({
                close_text: '<svg aria-hidden="true" class="promo__modaal--close" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><rect x="9" class="st0" width="2" height="20" style="fill: #9B9B9B;"></rect><rect x="9" transform="matrix(4.456506e-11 1 -1 4.456506e-11 20 -4.456506e-10)" width="2" height="20" style="fill: #9B9B9B;"></rect></svg>'
            });
        });
        
    }
});